import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function getRefPoli() {
  const response = await http
    .getData(`/klinik`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  getRefPoli
};
